<div class="oferta" *ngIf="!editando">
  <p class="oferta__texto" [class.oferta__texto--padrao]="ehPadrao">
    <i class="fas fa-tag" aria-hidden="true"></i>
    <span><strong>Oferta:</strong> {{ textoAtual }}</span>
  </p>
  <div class="oferta__botoes">
    <button type="button" (click)="abra()" [disabled]="sugerindo"><i class="fas fa-pen" aria-hidden="true"></i>{{ ehPadrao ? 'Combinar outra' : 'Editar' }}</button>
    <button type="button" *ngIf="urlSugerir" (click)="sugira()" [disabled]="sugerindo || !podeSugerir"
            [title]="podeSugerir ? 'A Mia lê a ficha e a conversa e sugere a oferta; você revisa e salva' : 'A Mia ainda não conversou com este lead'">
      <i class="fas" [ngClass]="sugerindo ? 'fa-spinner fa-spin' : 'fa-robot'" aria-hidden="true"></i>{{ sugerindo ? 'Pensando…' : 'Mia sugere' }}
    </button>
  </div>
  <p class="oferta__erro" role="alert" *ngIf="erro">{{ erro }}</p>
</div>

<form class="oferta oferta--form" *ngIf="editando" (ngSubmit)="salve()">
  <div class="oferta__campo">
    <label for="oferta-valor">Mensalidade (R$)</label>
    <input id="oferta-valor" name="ofertaValor" type="text" inputmode="decimal" [(ngModel)]="valor" (ngModelChange)="mexeu()"
           placeholder="124,90 (padrão)" [disabled]="salvando || sugerindo" autocomplete="off">
  </div>
  <label class="oferta__check">
    <input type="checkbox" name="comInicial" [(ngModel)]="comInicial" (ngModelChange)="mexeu()" [disabled]="salvando || sugerindo">
    <span>Valor menor nos primeiros meses</span>
  </label>
  <div class="oferta__inicial" *ngIf="comInicial">
    <input name="ofertaValorInicial" type="text" inputmode="decimal" [(ngModel)]="valorInicial" (ngModelChange)="mexeu()"
           placeholder="99,90" aria-label="Valor inicial (R$)" [disabled]="salvando || sugerindo" autocomplete="off">
    <span>por</span>
    <input name="ofertaMeses" type="number" min="1" max="24" step="1" [(ngModel)]="meses" (ngModelChange)="mexeu()"
           aria-label="Meses no valor inicial" [disabled]="salvando || sugerindo">
    <span>{{ meses === '1' ? 'mês' : 'meses' }}, depois a mensalidade acima</span>
  </div>
  <small class="oferta__sugestao" *ngIf="motivoSugestao"><i class="fas fa-robot" aria-hidden="true"></i>{{ motivoSugestao }}</small>
  <p class="oferta__previa" *ngIf="previa; else invalida"><i class="fas fa-eye" aria-hidden="true"></i>A Mia vai dizer: {{ previa }}</p>
  <ng-template #invalida><p class="oferta__previa oferta__previa--erro"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>Valores maiores que zero; o período inicial pede valor e de 1 a 24 meses.</p></ng-template>
  <p class="oferta__erro" role="alert" *ngIf="erro">{{ erro }}</p>
  <div class="oferta__botoes">
    <button type="submit" class="primario" [disabled]="salvando || sugerindo || !ofertaDoFormulario"><i class="fas" [ngClass]="salvando ? 'fa-spinner fa-spin' : 'fa-save'" aria-hidden="true"></i>Salvar</button>
    <button type="button" *ngIf="urlSugerir" (click)="sugira()" [disabled]="salvando || sugerindo || !podeSugerir"
            [title]="podeSugerir ? 'A Mia lê a ficha e a conversa e preenche aqui; você revisa e salva' : 'A Mia ainda não conversou com este lead'">
      <i class="fas" [ngClass]="sugerindo ? 'fa-spinner fa-spin' : 'fa-robot'" aria-hidden="true"></i>{{ sugerindo ? 'Pensando…' : 'Mia sugere' }}
    </button>
    <button type="button" (click)="limpe()" [disabled]="salvando || sugerindo" title="Limpa os campos; salvar volta o lead para a oferta padrão">Padrão</button>
    <button type="button" (click)="cancele()" [disabled]="salvando">Cancelar</button>
  </div>
</form>
